import React, { useState } from "react";
import { Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CustomLabel from "components/common/CustomLabel";

const TimePeriodSelector = ({ workspaceBookingDetails, selectedPeriods, setSelectedPeriods }) => {
  const { t } = useTranslation();

  const timePeriods = workspaceBookingDetails?.timePeriods || [];

  // Check if a period is selected by comparing IDs
  const isSelected = (id) =>
    selectedPeriods.some((item) => item.id === id);

  // Handle individual checkbox toggle
  const handleCheckboxChange = (period) => {
    setSelectedPeriods((prev) => {
      const exists = prev.some((item) => item.id === period.id);
      if (exists) {
        return prev.filter((item) => item.id !== period.id);
      } else {
        return [...prev, period];
      }
    });
  };

  // Handle Select All toggle
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allValid = timePeriods.filter(
        (p) => p.availableSeats > 0 && p.numberOfSeats === p.availableSeats
      );
      setSelectedPeriods(allValid);
    } else {
      setSelectedPeriods([]);
    }
  };

  // Check if all valid periods are selected
  const isAllSelected =
    timePeriods.filter(
      (p) => p.availableSeats > 0 && p.numberOfSeats === p.availableSeats
    ).length > 0 &&
    timePeriods
      .filter((p) => p.availableSeats > 0 && p.numberOfSeats === p.availableSeats)
      .every((p) => isSelected(p.id));

  const isSelectAllDisabled = timePeriods.some(
    (p) => p.numberOfSeats !== p.availableSeats
  );

  return (
    <>
      {timePeriods?.length > 0 && (
        <div className="">
          <CustomLabel htmlFor="timePeriods" label={t("Work Spaces")} />
      <Form.Group>
        <Form.Check
          type="checkbox"
          label="Select All"
          checked={isAllSelected}
          onChange={handleSelectAll}
          disabled={isSelectAllDisabled}
        />
        <div className="mt-2" style={{ maxHeight: 300, overflowY: "auto" }}>
          {timePeriods.map((period) => {
            const isDisabled =
              period.availableSeats === 0 ||
              period.numberOfSeats !== period.availableSeats;

            return (
              <Form.Check
                key={period.id}
                type="checkbox"
                label={`${period.name} (${period.time.start} - ${period.time.end})`}
                checked={isSelected(period.id)}
                onChange={() => handleCheckboxChange(period)}
                disabled={isDisabled}
              />
            );
          })}
        </div>
      </Form.Group>
           </div>
      )}
    </>
  );
};

export default TimePeriodSelector;